import React, { createContext, useContext, ReactNode } from "react";
import { useAuth, type User } from "@auth/frontend";
import { useUserAgents, type Agent } from "@agentic_conversation/api/agents";

interface UserChatContextValue {
  user: User | null;
  agents: Agent[] | undefined;
  isLoadingAgents: boolean;
  isAdminMode: false;
}

export const UserChatContext = createContext<UserChatContextValue | null>(null);

export function UserChatProvider({ children }: { children: ReactNode }) {
  const { user, isLoading: isLoadingAuth } = useAuth();
  const { data: agents, isLoading: isLoadingAgents } = useUserAgents();

  const value: UserChatContextValue = {
    user,
    agents,
    isLoadingAgents: isLoadingAuth || isLoadingAgents,
    isAdminMode: false,
  };

  return (
    <UserChatContext.Provider value={value}>
      {children}
    </UserChatContext.Provider>
  );
}

export function useUserChat(): UserChatContextValue | null {
  return useContext(UserChatContext);
}
